// extracted by mini-css-extract-plugin
export var cartDrawer = "drawer-module--cartDrawer--da7d7";
export var cartViewContainer = "drawer-module--cartViewContainer--eccc0";
export var closeButton = "drawer-module--closeButton--fd35d";
export var noticeBarVisible = "drawer-module--noticeBarVisible--12d52";